var parent = require('../../actual/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/instance/slice.js
// module id = 549
// module chunks = 0 1